// extracted by mini-css-extract-plugin
export default {"icon":"icon-VYp8SJK8"};